import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import type { ISeoConfig } from '@rpgc-ai/services/seo/seo.service';
import { SeoService } from '@rpgc-ai/services/seo/seo.service';
import { LanguageService } from '@rpgc-ai/services/translate/language.service';

import { TranslocoService } from '@jsverse/transloco';
import { map, take, tap } from 'rxjs';

const DEFAULT_SEO: ISeoConfig = {
  titleKey: 'SEO.HOME_TITLE',
  descriptionKey: 'SEO.HOME_DESCRIPTION',
};

export const translatedTitleResolver = (titleKey: string): ResolveFn<string> => () => {
  const transloco = inject(TranslocoService);

  return transloco.selectTranslation().pipe(
    take(1),
    map(() => transloco.translate(titleKey)),
  );
};

export const seoResolver: ResolveFn<void> = (route) => {
  const seoService = inject(SeoService);
  const transloco = inject(TranslocoService);
  const languageService = inject(LanguageService);
  const seo: ISeoConfig | undefined = route.data['seo'] ?? DEFAULT_SEO;

  if (!seo) {return;}

  // Ждём загрузки текущего языка, потом применяем SEO синхронно
  return transloco.selectTranslation().pipe(
    take(1),
    tap(() => {
      const title = transloco.translate(seo.titleKey);
      const desc = transloco.translate(seo.descriptionKey);
      seoService.setTitle(title);
      seoService.setTag('description', desc, 'name');
      seoService.setTag('og:title', title, 'property');
      seoService.setTag('og:description', desc, 'property');

      if (seo.canonicalPath) {
        seoService.setCanonicalPath(`/${languageService.getCurrentLanguage()}/${seo.canonicalPath}`);
      } else {
        seoService.removeCanonicalPath();
      }
    }),
    map(() => void 0),
  );
};
